import React from 'react'

import { Link } from 'gatsby'

import Image from '@components/Content/Image/Image'
import Wysiwyg from '@components/Content/Wysiwyg/Wysiwyg'

import { PostType } from '@contracts/Posts'

import * as styles from './NewsPostCard.module.scss'

import ArrowRightIcon from '@images/read_more_arrow.svg'

interface Props {
	post: PostType
	className?: string
	style: 'horizontal' | 'vertical'
}

const NewsPostCard = (props: Props) => {
	const { post } = props
	const { newsArticleOptions } = post

	const postClasses = [styles.postCard]

	if (props.style === 'horizontal') {
		postClasses.push(styles.horizontal)
	}

	if (props.className) {
		postClasses.push(props.className)
	}

	// Determine if we have an alternate image
	let alternateImage = null

	if (newsArticleOptions && newsArticleOptions.alternateImage) {
		alternateImage = newsArticleOptions.alternateImage
	} else if (post.featuredImage && post.featuredImage.node) {
		alternateImage = post.featuredImage.node
	}

	return (
		<div className={postClasses.join(' ')}>
			<div className={styles.imageContainer}>
				{alternateImage ? (
					<Link to={post.uri}>
						<Image image={alternateImage} altText={post.title} />
					</Link>
				) : (
					''
				)}
			</div>

			<div className={styles.meta}>
				<h3 className={styles.title}>
					<Link to={post.uri}>{post.title}</Link>
				</h3>

				<span className={styles.date}>{post.date}</span>

				<Wysiwyg content={post.excerpt} className={styles.excerpt} />

				<Link to={post.uri} className={styles.readMore}>
					Read <ArrowRightIcon />
				</Link>
			</div>
		</div>
	)
}

NewsPostCard.defaultProps = {
	style: 'vertical',
}

export default NewsPostCard
